'use strict';

var React = require('react');
var injectSheet = require('react-jss');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var THEME = require('pobble-components/dist/theme');
var pobbleUser = require('pobble-components/dist/pobble-user');
var classNames = require('classnames');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var injectSheet__default = /*#__PURE__*/_interopDefaultLegacy(injectSheet);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var THEME__default = /*#__PURE__*/_interopDefaultLegacy(THEME);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var BREAKPOINTS = THEME__default["default"].BREAKPOINTS;
var styles = {
  pendingTeacherBar: _defineProperty__default["default"]({
    background: '#d4e8fc',
    color: '#008bec',
    borderBottom: '1px solid #7dbaf5',
    width: '100%',
    padding: '10px 20px',
    fontSize: '14px',
    margin: 0
  }, "@media (min-width: ".concat(BREAKPOINTS.SM, ")"), {
    position: 'sticky',
    top: '0',
    left: '0',
    zIndex: '95'
  }),
  pendingTeacherLink: {
    textDecoration: 'none',
    color: '#008bec',
    fontWeight: 'bold'
  }
};

var PendingTeacherBar = function PendingTeacherBar(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      me = _ref.me;

  if (me && me.account && me.account.pending_teacher_type && (me.account.pending_teacher_type.school || me.account.pending_teacher_type.description)) {
    return /*#__PURE__*/React__default["default"].createElement("p", {
      className: classNames__default["default"](classes.pendingTeacherBar, className)
    }, "We\u2019re just verifying your school. We\u2019ll email you once this is complete.");
  } else {
    return /*#__PURE__*/React__default["default"].createElement(React.Fragment, null);
  }
};

PendingTeacherBar.propTypes = {
  /** Additional className if you want to restyle component */
  className: PropTypes__default["default"].string
};
var index = pobbleUser.withMe(injectSheet__default["default"](styles)(PendingTeacherBar));

module.exports = index;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/pobble-components/dist/pending-teacher-bar/index.js